<template>
    <div class="home">
        <div class="content">
            <div class="top">
                <div class="img"><img @click="toHome" src="../assets/slogo.png" alt=""></div>
            </div>
            <div class="bottom">
                <div class="navigationBar">
                    <div class="bar" @click="aboutUs">About Us</div>
                    <div class="bar" @click="aboutProducts">About Products</div>
                    <div class="bar" @click="contactUs">Contact Us</div>
                </div>
                <div class="contentByAboutUs" v-if="btnLinks == '1'">
                    <div class="title">About us and our strengths</div>
                    <img src="../assets/aboutPage/aboutUs.png" alt="">
                </div>
                <div class="contentByAboutProducts" v-else-if="btnLinks == '2'">
                    <div class="bar" @click="toHydrogen">Hydrogen compressor</div>
                    <div class="bar" @click="toCNG">CNG<br>compressor</div>
                </div>
                <div class="contentByContactUs" v-else>
                    <img src="../assets/logo.png" alt="">
                    <div style="line-height:40px;margin-top: 5vh;">
                        <div class="info" style="font-weight: bold;">SYNERGY FOR GAS s.r.l.</div>
                        <div class="info">PISTOIA (ITALIA) in Via PIEMONTE N 34 -51039</div>
                        <div class="info">Tel. 051-751873 Fax 051-751873</div>
                        <div class="info">C.F./P.Iva 03336671205</div>
                        <div class="info">Email: synergyforgas@gmail.com</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "About",
    components: {},
    data() {
        return {
            btnLinks: '1'
        };
    },
    mounted() {},
    methods: {
        toHome() {
            this.$router.push('/')
        },
        aboutUs() {
            this.btnLinks = '1'
            this.$router.push('/about')
        },
        aboutProducts() {
            this.btnLinks = '2'
        },
        contactUs() {
            this.btnLinks = '3'
            this.$router.push('/about')
        },
        toHydrogen() {
            this.$router.push('/hydrogenCompressor')
        },
        toCNG() {
            this.$router.push('/cngCompressor')
        },
    },
    created() {
        if (this.$route.query.btnLinks == '2') {
            this.btnLinks = this.$route.query.btnLinks;
        } else {
            this.btnLinks = '1'
        }
    },
};
</script>

<style scoped>
.home {
    background-position: center center;
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-size: cover;
    height: 100vh;
    background-image: url(../assets/bg1.png);
    padding: 20px;
    box-sizing: border-box;
}
.content .top .img img {
    width: 20%;
}
.content .top .img img:hover {
    cursor: pointer;
}
.content .bottom {
    display: flex;
    box-sizing: border-box;
}
.content .bottom .navigationBar {
    width: 20%;
    height: 80vh;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
}
.content .bottom .navigationBar .bar,.content .bottom .contentByAboutProducts .bar {
    width: 40%;
    height: 50px;
    padding: 10px 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-size: 18px;
    line-height: 25px;
    border-radius: 10px;
    border: 1.5px solid #ffc000;
    color: #ffc000;
    background: rgba(0,0,0,0);
}
.content .bottom .navigationBar .bar:hover,.content .bottom .contentByAboutProducts .bar:hover {
    background: #e3770a;
    border-color: #e3770a;
    color: #FFF;
    cursor: pointer;
}
.content .bottom .contentByAboutUs {
    height: 80vh;
    position: relative;
}
.content .bottom .contentByAboutUs .title {
    position: absolute;
    left: 18%;
    top: -10%;
    color: #ffc000;
    font-weight: 500;
    font-size: 26px;
}
.content .bottom .contentByAboutUs img {
    width: 100%;
    height: 100%;
}
.content .bottom .contentByAboutProducts {
    width:60%;
    margin-left:5%;
    height: 80vh;
    display: flex;
    justify-content: space-around;
    align-items: center;
    overflow: hidden;
}
@keyframes moveRight {
    0% { transform: translateX(-800px); }
    100% { transform: translateX(0px); }
}
.content .bottom .contentByAboutProducts .bar {
    width:25%;
    height: 90px;
    font-size: 20px;
    line-height: 30px;
    letter-spacing: 2px; /* 增加字母间距 */
    animation: moveRight 1.5s forwards;
}
.content .bottom .contentByContactUs {
    width: 65%;
    height: 80vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.content .bottom .contentByContactUs img {
    width: 55%;
}
.content .bottom .contentByContactUs .info {
    font-size: 26px;
    color: #ffc000;
    text-align: center;
    letter-spacing: 3px; /* 增加字母间距 */
}

</style>
